<template>
  <router-link :to="post.data.path" class="post">
    <RichImage :field="post.data.featured_image" />
    <time>{{ post.data.release | formatDate }}</time>
    <h3 class="marked marked--bottom">{{ post.data.title[0].text }}</h3>
  </router-link>
</template>

<script>
import dayjs from 'dayjs';

export default {
  filters: {
    formatDate(date) {
      return dayjs(date).format('MMMM YYYY');
    }
  },
  props: {
    post: {
      type: Object,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../scss/base/colors';
@import '../scss/helpers/mixins';

.post {
  display: block;
  margin-bottom: 1em;
  text-decoration: none;

  img {
    width: 100%;
    height: calc(50vw - 30px);
    border-radius: 5px;
    transition: transform 0.42s cubic-bezier(0.165, 0.84, 0.44, 1);
    object-fit: cover;
  }

  time {
    display: block;
    margin-top: 1em;
    color: $primary;
  }

  h3 {
    margin-top: 4px;
    margin-bottom: 1em;
    color: $titles;
  }

  &:hover {
    img {
      transform: translateY(-5px);
      box-shadow: 0 2px 4px rgba(40, 64, 78, 0.33);
    }

    h3 {
      text-decoration: underline;
    }
  }

  &:active {
    img {
      transform: translateY(0);
    }
  }
}
@include breakpoint(S) {
  .post {
    img {
      height: calc(5.5 * 30px);
    }
  }
}

@include breakpoint(M) {
  .post {
    padding: 0;
    margin-top: 20px;

    img {
      height: calc(3.5 * 40px);
    }
  }
}
@include breakpoint(L) {
  .post {
    margin-top: 25px;

    img {
      height: calc(3.5 * 50px);
    }
  }
}

@include breakpoint(XL) {
  .post {
    margin-top: 30px;

    img {
      height: calc(3.5 * 60px);
    }
  }
}
</style>
